const steps = [
  {
    icon: "ri-search-line",
    title: "搜索找漫",
    desc: "按题材或关键词快速定位，萌系、少女、甜宠一眼找到心头好。",
  },
  {
    icon: "ri-bookmark-line",
    title: "一键追更",
    desc: "收藏喜欢的漫画后，进度自动标记，续读、回看都方便。",
  },
  {
    icon: "ri-notification-3-line",
    title: "更新提醒",
    desc: "新话上线即刻收到提醒，再也不会错过每一格心动。",
  },
];

const features = [
  { icon: "ri-refresh-line", text: "收藏记录多端同步" },
  { icon: "ri-history-line", text: "追更进度实时记忆" },
  { icon: "ri-stack-line", text: "章节目录随时回看" },
  { icon: "ri-heart-pulse-line", text: "高甜剧情不虐心" },
];

export default function FollowGuide() {
  return (
    <section id="guide" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-semibold text-primary-600">轻松追更小贴士</p>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">三步开启你的甜蜜追更</h2>
          <p className="mt-3 text-sm text-foreground-600">
            收藏记录同步、更新提醒清晰，让每一部喜欢的恋爱漫画都不错过。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {steps.map((s, i) => (
            <li key={s.title} className="relative rounded-lg bg-background-50 p-6">
              <span className="absolute right-4 top-3 font-heading text-5xl text-primary-200" aria-hidden="true">
                {i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-xl text-background-50">
                <i className={s.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          {features.map((f) => (
            <span
              key={f.text}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm text-foreground-700"
            >
              <i className={`${f.icon} text-primary-600`} aria-hidden="true"></i>
              {f.text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}